import { faCheckCircle, faCircleInfo } from '@fortawesome/pro-solid-svg-icons';
import { Code, Icon, Text } from '@scale/scaleui-radix';
import { Column, ColumnSubType } from '@scale/compass-shared/types';

interface AutoIdentifyColumnProps {
  columns: Column[];
  columnSubType: ColumnSubType;
}

export const hasColumnSubtype = (columns: Column[], columnSubType: ColumnSubType) => {
  return columns.some(c => c.subType === columnSubType);
};

export const AutoIdentifyColumn = ({ columns, columnSubType }: AutoIdentifyColumnProps) => {
  const column = columns.find(c => c.subType === columnSubType);
  return (
    <div className="flex flex-col gap-2">
      <div className={`flex items-center gap-2 ${column ? 'text-neutral-600' : 'text-gray-400'}`}>
        <Icon
          icon={column ? faCheckCircle : faCircleInfo}
          size="sm"
          label="Info"
          className={column ? 'text-primary-600' : 'text-gray-400'}
        />
        <Text as="p" size="2">
          {column ? (
            <>
              Using column <Code>{column.header}</Code>&nbsp;to identify {columnSubType}
            </>
          ) : (
            `No column found for ${columnSubType}`
          )}
        </Text>
      </div>
    </div>
  );
};
